import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile, countries } from 'config/config'; // Importing configuration settings

/**
 * FilterView class extends JetView to create a filter form.
 */
export default class FilterView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Id
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Id'),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                            invalidMessage: _('Mensaje Id is required'), // Validation message
                        },
                        {
                            view: 'text', // Input for GlobalId
                            name: 'GlobalId',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Global Id'),
                            labelPosition: 'top',
                            placeholder: _('Global Id'),
                            invalidMessage: _('Global Id is required'), // Validation message
                        },
                        {
                            view: 'text', // Input for ClientId
                            name: 'ClientId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'richselect', // Dropdown for CountrySelect
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Custom template for country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Dropdown for CountrySelect2
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile
                            readonly: true, // Read-only field
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Custom template for country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry country-hide', // Combined CSS classes
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for DateSend
                            name: 'DateSend',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text', // Input for DateExpiration
                            name: 'DateExpiration',
                            css: 'reportrange',
                            readonly: true, // Read-only field
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect', // Dropdown for Read status
                            name: 'Read',
                            label: _('Leido?'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Si') },
                                { id: '0', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for State
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 360 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section with filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button', // Button to send popup
                            value: _('Enviar popup'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 180,
                            hidden: !devConfig.getPermAction('sendPopup', 'Add'), // Conditional visibility
                            css: 'prm-sendPopup',
                            click: () => {
                                this.app.callEvent('sendPopup:button', [[]]); // Event call on click
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to consult/filter
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('messages:filter', [filterdata]); // Trigger filter event
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [accordion_section1], // Accordion section as the main content
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements for small screens
                $$('grav2').hide();
            }
        });
    }
}

// FILE DOCUMENTED
